import CVCHealthCardInput from './CVCHealthCardInput.view';

export default CVCHealthCardInput;
